import { loadConfig } from '../../config';
import { Plugin } from '../../types';

export const hook: Plugin = {
  name: 'hook',
  test:{
    collector: true,
    hook: {
      async beforeAll(page, context): Promise<void>{
        const config = loadConfig()
        if(config.actions?.hook?.test?.beforeEach){
          await config.actions?.hook?.test?.beforeEach(page,context)
        }
      },
      async afterAll(page, context): Promise<void>{
        const config = loadConfig()
        if(config.actions?.hook?.test?.afterEach){
          await config.actions?.hook?.test?.afterEach(page,context)
        }
      }
    }
  },
}
export default hook

